import { render } from "./Erfassen.vue?vue&type=template&id=6e6630ac&scoped=true"
import script from "./Erfassen.vue?vue&type=script&lang=js"
export * from "./Erfassen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Bleckmann\\lions-adventskalender-frontend-bocholt\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e6630ac"]])

export default __exports__